import React, { useState } from 'react';
import '../../css/AideDeJeu.css';
import indices from '../../components/enigmes/e_indices.js';

function AideDeJeu() {

    const [activeBook, setActiveBook] = useState('Livre 1');
    const [activeChapter, setActiveChapter] = useState('Chapitre 1');
    const [activePage, setActivePage] = useState('6 & 7');
    const [visibleHints, setVisibleHints] = useState({}); // État pour la visibilité des indices

    const handleHintToggle = (hintNumber, hint) => {
        setVisibleHints(prev => ({
            ...prev,
            [`${hintNumber}-${hint}`]: !prev[`${hintNumber}-${hint}`]
        }));
    };

    return (
        <div>



            <div className="espaceHaut"></div>
            <div className='aide-de-jeux text-center fondParchemin'>
                <h1>Aide de jeu</h1>
                <div className="index-links">
                    <a href="#conseils" className="btn">Conseils</a>
                    {/* <span> • </span> */}
                    <a href="#indices" className="btn">Indices</a>
                    {/* <span> • </span> */}
                    <a href="#encre-invisible" className="btn">Encre invisible</a>
                </div>
            </div>

            <div id='conseils' className='fondParchemin'>
                <h2 className=''>Avant de débuter : quelques conseils pour se lancer dans l'univers</h2>
                <div className="row">
                    <div className="col-md-6">
                        <p><b>1)</b> La difficulté de ce livre d’énigmes illustré est d’un niveau avancé (Il est long et parfois difficile. Comptez <b>au moins 40 heures</b> pour résoudre ou trouver toutes les solutions, voire plus. Il n’y a pas de chronomètre, ce n’est pas un escape game classique solvable en une heure. Les premières heures sont consacrées bien souvent à la lecture et découverte des premiers indices cachés. Ce livre demande de l’implication. Aussi est-il réservé à un public adulte (mais des ados peuvent également le faire). Il n’est pas recommandé pour des enfants du fait de sa difficulté, mais vous pouvez tout à fait accompagner l'enfant et lui expliquer les énigmes, ou bien le laisser s’amuser avec la lampe pour découvrir les choses cachées.</p>

                        <p><b>2)</b> Ne commencez pas par les pages 6 et 7 mais plutôt les suivantes. Ces pages-là sont importantes, mais vous ne pourrez rien résoudre sur ces deux pages sans avoir effectué tout le chapitre en entier.</p>

                        <p><b>3)</b> Sur certaines pages, vous trouverez des <b>indices</b> qui vous permettront de <b>résoudre d’autres doubles pages</b>. Si vous trouvez des mots ou des symboles qui ne vous servent à rien, alors n’hésitez pas à vous en souvenir : ils pourraient être très importants pour des énigmes suivantes !</p>

                        <p><b>4)</b> Il y a <b>une énigme par double page</b>. La réponse à cette énigme est soit un nombre, un mot ou un symbole. Cela ne pourra jamais être 5 mots, 2 symboles ou 4 chiffres par exemple. Si vous trouvez 6 mots, alors il y a forcément un moyen à trouver pour choisir le bon, ou peut-être forment-ils une phrase.</p>

                        <p><b>5)</b> L’importance des <b>textes</b>: tous les éléments de la double page sont importants, les illustrations bien sûr mais aussi le texte. Le texte vous donnera souvent une foule d’indices avec des sens cachés, des jeux de mots, des doubles sens, des anagrammes etc... Attention à bien comprendre le texte et à essayer de voir le texte autrement 😉</p>

                        <p>L’importance des <b>illustrations</b> : beaucoup de choses sont cachées dans les images, regardez attentivement partout. De loin, en penchant le livre, de près..</p>
                    </div>
                    <div className="col-md-6">
                        <p><b>6)</b> Il n’est pas nécessaire d’écrire, de couper ou de maltraiter le livre. Un papier calque est cependant conseillé ou des feuilles volantes, cahier etc…</p>

                        <p><b>7)</b> Toutes les réponses sont écrites dans le livre, à vous de les trouver ! Si on vous demande de trouver un site internet, c’est bien souvent celui sur lequel vous lisez ces mots.</p>

                        <p><b>8)</b> Si vous bloquez sur une énigme, passez, vous y reviendrez ! Vous n’êtes pas obligé de faire le livre de manière linéaire, mais on recommande de faire chapitre par chapitre. Vous pouvez donc par exemple résoudre l’énigme 8 du chapitre 1 avant de résoudre la 2 du chapitre 1.</p>

                        <p><b>9)</b> Vous pouvez demander de l’aide sur le <a href="https://discord.gg/invite/sTkE7vz" target="_blank" rel="noreferrer">serveur Discord</a>, demander des indices à la communauté en plus des indices de cette page. Vous pouvez également valider vos raisonnements et réponses avec la communauté. C’est très recommandé et bienvenue, et vous pourrez également parler aux auteurs Fanélia et Taharn présents sur le serveur !</p>

                        <i><b>Fonctionnement du serveur Discord :</b>
                            <ul>
                                <li>Les différents canaux/salons à gauche permettent d’accéder aux discussions de la communauté sur les doubles pages du livre. Ces doubles pages sont regroupées en 5 chapitres.</li>
                                <li>Si vous avez des questions ou bien la solution d’une double page, veuillez rédiger votre demande sur le canal/salon adéquat.</li>
                                <li>Ne divulguez pas la réponse ou la solution directement, veuillez utiliser les messages privés (MP) : pour cela cliquez sur l’avatar de la personne qui est disponible pour vous aider et cliquez sur envoyer un message.</li>
                            </ul>
                        </i>

                        <p><b>10)</b> Il n'y a pas forcément d’encre invisible sur toutes les pages. Une lampe vous a été fournie avec le livre : si vous ne l’avez pas, contactez votre revendeur 🙂</p>

                        <p><b>11)</b> Commencez par faire une première lecture pour vous imprégner de l’histoire.</p>

                        <p><b>12)</b> Quand vous pensez avoir fini tout le livre alors rendez-vous sur la <a href="/validation">page de validation</a> !</p>
                    </div>
                </div>




            </div>
            <br />

            <div id='indices' className='fondParchemin'>
                <h2 className=''>Indices</h2>
                <p>L’indice numéro 1 vous éclairera <strong>légèrement</strong>.<br />
                    L’indice numéro 2 vous éclairera <strong>beaucoup</strong>.<br />
                    Essayez d’abord l’indice 1 puis venez au numéro 2 si vous n’y arrivez toujours pas :)</p>

                <div className='row livre-buttons'>
                    {/* Boutons de sélection des livres */}
                    <div className="d-flex flex-wrap justify-content-center" role="group" aria-label="Book Switcher">
                        {Object.keys(indices).map(book => (
                            <button
                                key={book}
                                type="button"
                                className={`btn ${activeBook === book ? 'btn-in' : 'btn-out'}`}
                                onClick={() => {
                                    setActiveBook(book);
                                    setActiveChapter(Object.keys(indices[book])[0] || ''); // Réinitialiser le chapitre à celui par défaut
                                    setActivePage(Object.keys(indices[book][Object.keys(indices[book])[0]] || {})[0] || ''); // Réinitialiser la page à celle par défaut
                                }}
                            >
                                {book}
                            </button>
                        ))}
                    </div>
                </div>
                <hr className='hr-indices' />



                <div className='row chapitre-buttons'>
                    {/* Boutons de sélection des chapitres */}
                    {Object.keys(indices[activeBook] || {}).length > 0 && (
                        <div className="d-flex flex-wrap justify-content-center" role="group" aria-label="Chapter Switcher">
                            {Object.keys(indices[activeBook] || {}).map(chapter => (
                                <button
                                    key={chapter}
                                    type="button"
                                    className={`btn btn-chapter ${activeChapter === chapter ? 'btn-in' : 'btn-out'}`}
                                    onClick={() => {
                                        setActiveChapter(chapter);
                                        setActivePage(Object.keys(indices[activeBook][chapter] || {})[0] || ''); // Réinitialiser la page à celle par défaut
                                    }}
                                >
                                    {chapter}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
                <hr className='hr-indices' />




                {/* Boutons de sélection des pages */}
                {Object.keys(indices[activeBook]?.[activeChapter] || {}).length > 0 && (
                    <div className="page-buttons">
                        <div className="d-flex flex-wrap justify-content-center">
                            {Object.keys(indices[activeBook][activeChapter] || {}).map((page, index) => (
                                <div key={page}>
                                    <button
                                        type="button"
                                        className={`btn btn-page ${activePage === page ? 'btn-in' : 'btn-out'}`}
                                        onClick={() => setActivePage(page)}
                                    >
                                        {page}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Affichage des indices de la page active */}
                <div className='modal-indices'>
                    <h3>{activeBook} / {activeChapter} / Pages {activePage}</h3>
                    {Object.entries(indices[activeBook]?.[activeChapter]?.[activePage] || {}).map(([hintNumber, hint]) => (
                        <div className="d-flex" key={hintNumber}>
                            <button
                                type="button"
                                className={`btn btn-page mr-2 btn-right-cut ${visibleHints[`${hintNumber}-${hint}`] ? 'btn-in' : 'btn-out'}`}
                                onClick={() => handleHintToggle(hintNumber, hint)}
                            >
                                Indice {hintNumber}
                            </button>
                            {visibleHints[`${hintNumber}-${hint}`] && (
                                <p style={{ margin: '10px' }}> {hint}</p>
                            )}
                        </div>
                    ))}
                </div>

            </div>
            <br />

            <div id='encre-invisible' className='text-center'>
                <h2 className=''>Encre invisible</h2>
                <a target='_blank' rel='noreferrer' className='link-capsule btn' href="https://www.laclef.online/encres/ence_invisible2021_version_finale04.pdf">Télécharger le PDF des encres invisibles</a>
            </div>
        </div >
    );
}

export default AideDeJeu;
